import { render, staticRenderFns } from "./HeroPrototype.vue?vue&type=template&id=33758a7b&scoped=true&"
import script from "./HeroPrototype.vue?vue&type=script&lang=ts&"
export * from "./HeroPrototype.vue?vue&type=script&lang=ts&"
import style0 from "./HeroPrototype.vue?vue&type=style&index=0&id=33758a7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33758a7b",
  null
  
)

export default component.exports